// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"PrintingStatusModal_modalContainer__2gMaR","overflow":"PrintingStatusModal_overflow__2KUBR"};